export default {
  getAll: {
    method: 'post',
    url: '/client/company/speed-assumptions/list'
  },
  create: {
    method: 'post',
    url: '/client/company/speed-assumptions'
  },
  update: {
    method: 'put',
    url: '/client/company/speed-assumptions/update'
  },
  delete: {
    method: 'delete',
    url: '/client/company/speed-assumptions'
  }
}
